import { Box, Flex } from "@chakra-ui/react";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/shared/session";
import { trackEvent } from "@/utils/firebase/analytics";
import { SIDEBAR_WIDTH, Sidebar } from "../navbars/Sidebar";
import { MobileTopBar } from "../navbars/MobileTopBar";
import {
  DrawerBackdrop,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerRoot,
} from "../chakra/drawer";

const SIDEBAR_STORAGE_KEY = "sidebarCollapsed";

const MainLayout = () => {
  const location = useLocation();
  const { session } = useAuth();
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(SIDEBAR_STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    trackEvent("page_view");
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_STORAGE_KEY, collapsed ? "1" : "0");
    } catch {
      return;
    }
  }, [collapsed]);

  return (
    <Flex
      minH="100dvh"
      bg="bg.canvas"
      align="stretch"
      direction={{ base: "column", lg: "row" }}
    >
      <Box display={{ base: "none", lg: "block" }} flexShrink={0}>
        <Sidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed((prev) => !prev)}
        />
      </Box>

      <MobileTopBar onOpenMenu={() => setMenuOpen(true)} />
      <DrawerRoot
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        placement="start"
      >
        <DrawerBackdrop />
        <DrawerContent maxW={SIDEBAR_WIDTH} bg="bg.sidebar">
          <DrawerCloseTrigger />
          <Sidebar collapsed={false} />
        </DrawerContent>
      </DrawerRoot>

      <Box flex={1} minW={0} key={session?.zone ?? "sin-zona"}>
        <Outlet />
      </Box>
    </Flex>
  );
};

export default MainLayout;
